import { DeliveryDateType, DocumentType, GenericObject, copyFields } from '@synergy/models';

import { ConverterCustomer } from './converter-customer';
import { TransitionSource } from '../type-transition-source';
import { TransitionTarget } from './transition-target';

export class ConverterJob {
    public source!: TransitionSource;
    public possibleTargets!: TransitionTarget[];
    public selectedTarget!: TransitionTarget;
    public customers!: ConverterCustomer[];
    public selectedCustomerId!: number;
    public documentType!: DocumentType;
    public supportsDeliveryCosts!: boolean;
    public deliveryDateRange?: { from: Date; to: Date };
    public hasDeliveryDate!: boolean;
    public deliveryDate?: Date;
    public deliveryDateType?: DeliveryDateType;

    public static fromPlainObject(object: GenericObject): ConverterJob {
        const job = new ConverterJob();

        copyFields(object, job);

        if (object['customers']) {
            job.customers = object['customers'].map(ConverterCustomer.fromPlainObject);
        }

        // A locked partner is not carried into the following document, so none
        // of its positions starts out picked — the inquiry hands the best offer
        // in already picked (GF 12.10.2026, #2230).
        job.customers?.forEach(customer =>
            customer.customerSuppliers?.forEach(supplier => {
                if (customer.isLocked || supplier.isLocked) {
                    supplier.items?.forEach(item => (item.isSelected = false));
                }
            })
        );

        return job;
    }
}
